import React from "react";

const LotusIcon = ({ size = 24, className = "" }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 100 100" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Center petal */}
    <path 
      d="M50 10C50 10 40 35 40 50C40 65 50 75 50 75C50 75 60 65 60 50C60 35 50 10 50 10Z" 
      fill="currentColor" 
      fillOpacity="0.9"
    />
    
    {/* Left inner petal */}
    <path 
      d="M35 25C35 25 20 45 22 58C24 71 38 75 38 75C38 75 42 60 42 50C42 40 35 25 35 25Z" 
      fill="currentColor" 
      fillOpacity="0.7"
    />
    
    {/* Right inner petal */}
    <path 
      d="M65 25C65 25 80 45 78 58C76 71 62 75 62 75C62 75 58 60 58 50C58 40 65 25 65 25Z" 
      fill="currentColor" 
      fillOpacity="0.7"
    />
    
    {/* Left outer petal */}
    <path 
      d="M22 35C22 35 5 50 8 65C11 80 30 82 30 82C30 82 28 65 30 55C32 45 22 35 22 35Z" 
      fill="currentColor" 
      fillOpacity="0.5"
    />
    
    {/* Right outer petal */}
    <path 
      d="M78 35C78 35 95 50 92 65C89 80 70 82 70 82C70 82 72 65 70 55C68 45 78 35 78 35Z" 
      fill="currentColor" 
      fillOpacity="0.5"
    />
    
    {/* Base/water line */}
    <ellipse 
      cx="50" 
      cy="85" 
      rx="35" 
      ry="8" 
      fill="currentColor" 
      fillOpacity="0.3"
    />
  </svg>
);

export default LotusIcon;
